export default "__VITE_ASSET__DqHxwe_p__"